import get from 'lodash/get'

export const isProEnabled = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  return !!channelData.features.find(({ name, enabled }) => name === 'proWebinar' && enabled === true)

}
